import React from "react";
import { Accordion, Card } from "react-bootstrap";
import AddressDetails from "./AddressDetails";
import s from "./style.module.css";

const AddressesDetails = ({ contractorId, contractorTypes, addresses }) => {
  const activeEventKey = addresses?.[0]?.id;
  return (
      <Card className={s.sectionCard}>
        <Card.Header as="h4">Adresy</Card.Header>
        <Card.Body className="upper">
          <div className={s.group}>

            <Accordion alwaysOpen defaultActiveKey={activeEventKey}>
            {addresses?.map((address) => (
              <AddressDetails key={address.id} contractorId={contractorId} contractorTypes={contractorTypes} address={address} />
            ))}
            </Accordion>
          </div>
        </Card.Body>
      </Card>
  );
};

export default AddressesDetails;
